import { Component } from 'react';

class TreeComponent extends Component {
    render() {
        let { _pageScope, id, treeType, ...others } = this.props;
        others.treeId = id;
        if(treeType === "syncTree") {
            return _pageScope.props.syncTree.createSyncTree(others);
        }else{
            return _pageScope.props.asyncTree.createAsyncTree(others);
        }
    }
}

export default TreeComponent;